import * as React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  muiSVG: {
    fill: 'currentColor',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fontSize: '1.5rem',
    transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    flexShrink: '0',
    userSelect: 'none',
  }
}));

export const IdCard = () => {
  const classes = useStyles()

  return (
<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M576-455h183v-57.5H576v57.5Zm0-116.5h183V-629H576v57.5Zm-374.5 250h316v-21q0-41-42-67t-116.25-26q-74.25 0-116 26t-41.75 67v21Zm157.67-174q29.59 0 50.71-20.96Q431-537.41 431-566.84q0-29.42-20.98-50.54-20.98-21.12-50.44-21.12-29.84 0-50.71 20.96Q288-596.59 288-567.16q0 29.42 20.79 50.54 20.79 21.12 50.38 21.12Zm-216.67 331q-22.97 0-40.23-17.27Q85-199.03 85-222v-516q0-22.97 17.27-40.23 17.26-17.27 40.23-17.27h675q22.97 0 40.23 17.27Q875-760.97 875-738v516q0 22.97-17.27 40.23-17.26 17.27-40.23 17.27h-675Zm0-57.5h675v-516h-675v516Zm0 0v-516 516Z"/></svg>)
}

